export const ADMIN_URL_HOME = '/admin'
export const ADMIN_COMMUNITIES_LABEL = 'Communities'
export const ADMIN_COMMUNITIES_URL = `${ADMIN_URL_HOME}/communities`
export const ADMIN_REPORTS_URL = `${ADMIN_URL_HOME}/reports`
export const ADMIN_EXCLUDED_URL = `${ADMIN_URL_HOME}/excluded-lists`
export const ADMIN_ENGAGEMENT_SUMMARY_URL = `${ADMIN_URL_HOME}/deliverability-summary`
export const ADMIN_DOMAIN_DELIVERABILITY_SUMMARY_URL = `${ADMIN_URL_HOME}/domain-deliverability`
export const ADMIN_NEWSBRIEF_COUNTS_URL = `${ADMIN_URL_HOME}/newsletters`
export const ADMIN_NEWSBRIEF_SUMMARY_URL = `${ADMIN_URL_HOME}/newsletter-summary/`
export const ADMIN_UPCOMING_SCHEDULES_URL = `${ADMIN_URL_HOME}/upcoming-schedules`
export const ADMIN_FEEDBACK_URL = `${ADMIN_URL_HOME}/feedback`
export const ADMIN_DROPS_URL = `${ADMIN_URL_HOME}/drops`
export const ADMIN_USERS_URL = `${ADMIN_URL_HOME}/users`
export const ADMIN_IP_POOLS_URL = `${ADMIN_URL_HOME}/ip-pools`
export const ADMIN_DOMAIN_AUTH_URL = `${ADMIN_URL_HOME}/domain-authentication`

export const COMMUNITY_URL_HOME = '/community'
export const COMMUNITY_CONFIG_URL = `${COMMUNITY_URL_HOME}/config`
export const NEWSLETTER_CREATE_URL = `${COMMUNITY_URL_HOME}/create`
export const ACCOUNT_CREATE_URL = `${COMMUNITY_URL_HOME}/account/create`

export const CONTENT_LABEL = 'Content'
export const CONTENT_URL_HOME = '/content'
export const CONTENT_CALENDAR_LABEL = 'Content Calendar'
export const CONTENT_CALENDAR_URL = `${CONTENT_URL_HOME}/calendar`
export const CONTENT_FILTERGROUP_URL = `${CONTENT_URL_HOME}/filter-group`
export const CONTENT_FILTERGROUPS_URL = `${CONTENT_URL_HOME}/filter-groups`
export const CONTENT_POSTS_LABEL = 'Posts'
export const CONTENT_POSTS_URL = `${CONTENT_URL_HOME}/posts`
export const CONTENT_SOURCES_LABEL = 'Sources'
export const CONTENT_SOURCES_URL = `${CONTENT_URL_HOME}/sources`
export const CONTENT_SOURCE_URL = `${CONTENT_URL_HOME}/source`
export const CONTENT_IMPORTS_URL = `${CONTENT_URL_HOME}/imports`
export const CONTENT_IMPORTS_ERRORS_URL = `${CONTENT_URL_HOME}/imports/errors`
export const CONTENT_LEAD_POSTS_LABEL = 'Lead Posts'
export const CONTENT_LEAD_POSTS_URL = `${CONTENT_URL_HOME}/lead-posts`
export const CONTENT_LEAD_TEXT_LABEL = 'Lead Text'
export const CONTENT_LEAD_TEXT_URL = `${CONTENT_URL_HOME}/lead-text`
export const CONTENT_PROMOTIONS_LABEL = 'Promotions'
export const CONTENT_PROMOTIONS_URL = `${CONTENT_URL_HOME}/promotions`
export const CONTENT_TRAINING_LABEL = 'AI Training Data'
export const CONTENT_TRAINING_URL = `${CONTENT_URL_HOME}/training`

export const SUBSCRIBERS_LABEL = 'Subscribers'
export const SUBSCRIBERS_URL_HOME = '/subscribers'
export const SUBSCRIBERS_SUBSCRIBER_DETAIL_URL = `${SUBSCRIBERS_URL_HOME}/details`

export const AUTH_URL_HOME = '/oauth'
export const AUTH_LOGIN_URL = `${AUTH_URL_HOME}/login`
export const AUTH_LOGOUT_URL = '/logout'
export const AUTH_ONBOARD_URL = '/onboard'
export const AUTH_RESET_PASSWORD_URL = '/reset-password'
export const AUTH_FORGOT_PASSWORD_URL = '/forgot-password'
export const AUTH_FORGOT_PASSWORD_SUCCESS_URL = '/forgot-password-success'
export const AUTH_LOGIN_VALIDATION_URL = '/login'
export const AUTH_COGNITO_LOGIN_URL = '/auth/login'

export const NEWSLETTER_LABEL = 'Settings'
export const NEWSLETTER_URL_HOME = '/newsletter'
export const NEWSLETTER_SETTINGS_LABEL = 'Settings'
export const NEWSLETTER_SETTINGS_URL = `${NEWSLETTER_URL_HOME}/settings`
export const NEWSLETTER_SCHEDULES_LABEL = 'Schedules'
export const NEWSLETTER_SCHEDULES_URL = `${NEWSLETTER_URL_HOME}/schedules`
export const NEWSLETTER_CAMPAIGNS_LABEL = 'Campaigns'
export const NEWSLETTER_CAMPAIGNS_URL = `${NEWSLETTER_URL_HOME}/campaigns/referral`

export const REPORTS_LABEL = 'Analytics'
export const REPORTS_URL_HOME = '/reports'
export const REPORTS_ANALYTICS_URL = `${REPORTS_URL_HOME}/opens-clicks`
export const REPORTS_ANALYTICS_LABEL = 'Opens/Clicks'
export const REPORTS_OTHER_CLICKS_URL = `${REPORTS_URL_HOME}/other-clicks`
export const REPORTS_OTHER_CLICKS_LABEL = 'Other Clicks'
export const REPORTS_ENGAGEMENT_URL = `${REPORTS_URL_HOME}/engagement`
export const REPORTS_ENGAGEMENT_LABEL = 'Engagement'
export const REPORTS_KNOWLEDGETIERS_URL = `${REPORTS_URL_HOME}/knowledge-tiers`
export const REPORTS_KNOWLEDGETIERS_LABEL = 'AI Knowledge Tiers'
export const REPORTS_DAILY_URL = `${REPORTS_URL_HOME}/daily`
export const REPORTS_DAILY_LABEL = 'Daily Stats'
export const REPORTS_SOURCES_URL = `${REPORTS_URL_HOME}/top-sources`
export const REPORTS_SOURCES_LABEL = 'Sources'
export const REPORTS_ADVERTISING_URL = `${REPORTS_URL_HOME}/top-ads`
export const REPORTS_ADVERTISING_LABEL = 'Advertising'
export const REPORTS_ARTICLES_URL = `${REPORTS_URL_HOME}/top-articles`
export const REPORTS_ONBOARDING_SESSIONS = `${REPORTS_URL_HOME}/onboarding-sessions`
export const REPORTS_ARTICLES_LABEL = 'Articles'
export const REPORTS_TOPICS_URL = `${REPORTS_URL_HOME}/top-topics`
export const REPORTS_TOPICS_LABEL = 'Topics'
export const REPORTS_OLD_ADVERTISING_URL = `${REPORTS_URL_HOME}/advertising`
export const REPORTS_OLD_ARTICLES_URL = `${REPORTS_URL_HOME}/articles`
export const REPORTS_OLD_SOURCES_URL = `${REPORTS_URL_HOME}/sources`

export const USER_URL_HOME = '/user'
export const USER_SETTINGS_URL = `${USER_URL_HOME}/settings`

export const USERS_URL_HOME = '/users'
export const USERS_URL = USERS_URL_HOME

export const INTEGRATIONS_LABEL = 'Integrations'
export const INTEGRATIONS_URL_HOME = '/integrations'
export const INTEGRATIONS_CONFIG_URL = `${INTEGRATIONS_URL_HOME}/config`
export const INTEGRATIONS_CONNECT_URL = `${INTEGRATIONS_URL_HOME}/connect`
export const INTEGRATIONS_PLUGINS_URL = `${INTEGRATIONS_URL_HOME}/plugins`
export const INTEGRATIONS_TYPES_URL = `${INTEGRATIONS_URL_HOME}/types`
export const INTEGRATIONS_TYPE_DETAILS_URL = `${INTEGRATIONS_URL_HOME}/types/type-details`
export const INTEGRATION_MAPPINGS_URL = `/integration/mappings`
export const INTEGRATION_REPORTS_URL = `/integration/reports`

export const HELP_URL = 'https://help.rasa.io'



// WEBPACK FOOTER //
// ./src/components/menu/constants.ts